import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark : false,
        themes: {
            dark: {
                primary: "#263238",
                secondary: "#028cba"
            },
            light: {
                primary: "#263238",
                secondary: "#028cba"
            },
        },
    },
});
